export default "<div> <high-chart options=vm.options style=height:500px;width:100%;display:block;overflow:hidden /> <div ng-if=\"!vm.showIfEmpty && vm.options.series && !vm.options.series.length\"> No Cavities for this Shop </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/reports/cavityEfficiencySummaryGraph.tpl.html
// module id = 790
// module chunks = 0